import React from 'react'
import Helmet from 'react-helmet'
import Link from 'gatsby-link'
import get from 'lodash/get'
import Header from '../components/header/Header'
import LayoutContainer from '../components/shared/LayoutContainer'
import EventDetails from '../components/events/EventDetails'
import MenuItem from '../components/header/menu/MenuItem'

class EventTemplate extends React.Component {
  render() {
    const post = this.props.data.markdownRemark
    const siteTitle = get(this.props, 'data.site.siteMetadata.title')
    const { previous, next } = this.props.pathContext

    return (
      <div>
        <Header hide_details hide_claim>
          <Link to="/" style={{ color: 'inherit' }}>
            <MenuItem>Startseite</MenuItem>
          </Link>
        </Header>
        <LayoutContainer styles={{ borderBotom: 0 }}>
          <Link to="/" style={{ color: 'inherit', marginBottom: '2rem', display: 'block' }}>
            &larr; zurück
          </Link>
          <h2>{post.frontmatter.title}</h2>
          <EventDetails
            date={post.frontmatter.displayDate}
            location={post.frontmatter.location}
            style={{ marginBottom: '2rem' }}
          />
          <div dangerouslySetInnerHTML={{ __html: post.html }} />
        </LayoutContainer>
      </div>
    )
  }
}

export default EventTemplate

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        title
      }
    }
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      html
      frontmatter {
        title
        description
        date(formatString: "MMMM DD, YYYY")
        displayDate
        location
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/event.js